import React from 'react';
import ButtonWithProgress from '../_shared/ui-components/YogaUI/ButtonWithProgress';
import { buttonProgressExample, buttonsExample } from './codeExamples';

const ButtonsList = () => {
  return (
    <>
      <p className="editorial-large semibold items mb-md">
        Buttons (
        <a
          className="editorial-large semibold underline"
          href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=9905-11612&m=dev"
        >
          Reference
        </a>
        )
      </p>
      <div className="column body-large mb-xl">
        <p>Example usage:</p>
        <p>
          <span className="body-large semibold mb-sm">Large (default):</span>{' '}
          <code className="code-example">class="button-primary"</code>
        </p>
        <p>
          <span className="body-large semibold">Medium, Small, XS:</span>{' '}
          <code className="code-example">class="button-primary-xs"</code>
        </p>
        <p>
          If you need to use an <code className="code-example">{'<a>'}</code> tag styled like a button, please add{' '}
          <code className="code-example">class="link-styled-as-button"</code> to prevent the default link styles from
          being added to the button hover state.
        </p>
      </div>
      <div className="grid-container">
        {/* Light Buttons */}
        <div className="light-buttons">
          <p className="full-width-grid-item editorial-large center">Light BG</p>
          <div className="item"></div>
          <div className="item"></div>
          <p className="item body button-header">Primary</p>
          <p className="item body button-header">Dim</p>
          <div className="full-height-grid-item item">Large</div>
          <p className="item body button-header">Rest</p>
          <div className="item">
            <button className="button-primary">Button</button>
          </div>
          <div className="item">
            <button className="button-dim">Button</button>
          </div>
          <p className="item button-header">Hover</p>
          <div className="item">
            <button className="button-primary hover">Button</button>
          </div>
          <div className="item"></div>
          <p className="item button-header">Disabled</p>
          <div className="item">
            <button className="button-primary" disabled>
              Button
            </button>
          </div>
          <div className="item"></div>
          <p className="item body button-header">Progress</p>
          <div className="item">
            <ButtonWithProgress
              options={{
                showProgressAnimation: true,
                buttonTypeClass: 'button-primary',
                buttonClasses: 'button-progress',
                cta: 'Button',
              }}
            />
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="full-height-grid-item item">Medium</div>
          <p className="item body button-header">Rest</p>
          <div className="item">
            <button className="button-primary-md">Button</button>
          </div>
          <div className="item">
            <button className="button-dim-md">Button</button>
          </div>
          <p className="item button-header">Hover</p>
          <div className="item">
            <button className="button-primary-md hover">Button</button>
          </div>
          <div className="item"></div>
          <p className="item button-header">Disabled</p>
          <div className="item">
            <button className="button-primary-md" disabled>
              Button
            </button>
          </div>
          <div className="item"></div>
          <p className="item body button-header">Progress</p>
          <div className="item">
            <ButtonWithProgress
              options={{
                showProgressAnimation: true,
                buttonTypeClass: 'button-primary-md',
                cta: 'Button',
              }}
            />
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="full-height-grid-item span-3 item">Small</div>
          <p className="item body button-header">Rest</p>
          <div className="item">
            <button className="button-primary-sm">Button</button>
          </div>
          <div className="item">
            <button className="button-dim-sm">Button</button>
          </div>
          <p className="item button-header">Hover</p>
          <div className="item">
            <button className="button-primary-sm hover">Button</button>
          </div>
          <div className="item"></div>
          <p className="item button-header">Disabled</p>
          <div className="item">
            <button className="button-primary-sm" disabled>
              Button
            </button>
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="full-height-grid-item span-3 item">X-Small</div>
          <p className="item body button-header">Rest</p>
          <div className="item">
            <button className="button-primary-xs">Button</button>
          </div>
          <div className="item">
            <button className="button-dim-xs">Button</button>
          </div>
          <p className="item button-header">Hover</p>
          <div className="item">
            <button className="button-primary-xs hover">Button</button>
          </div>
          <div className="item"></div>
          <p className="item button-header">Disabled</p>
          <div className="item">
            <button className="button-primary-xs" disabled>
              Button
            </button>
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
        </div>

        {/* Dark Buttons */}
        <div className="dark-buttons">
          <p className="full-width-grid-item editorial-large center white">Dark BG</p>
          <p className="item button-header">Ghost</p>
          <p className="item button-header">Invert</p>
          <div className="item">
            <button className="button-ghost">Button</button>
          </div>
          <div className="item">
            <button className="button-invert">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost hover">Button</button>
          </div>
          <div className="item">
            <button className="button-invert hover">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost" disabled>
              Button
            </button>
          </div>
          <div className="item">
            <button className="button-invert" disabled>
              Button
            </button>
          </div>
          <div className="item">
            <ButtonWithProgress
              options={{
                showProgressAnimation: true,
                buttonTypeClass: 'button-ghost',
                buttonClasses: 'button-progress-lg',
                cta: 'Button',
              }}
            />
          </div>
          <div className="item">
            <ButtonWithProgress
              options={{
                showProgressAnimation: true,
                buttonTypeClass: 'button-invert',
                cta: 'Button',
              }}
            />
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item">
            <button className="button-ghost-md">Button</button>
          </div>
          <div className="item">
            <button className="button-invert-md">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost-md hover">Button</button>
          </div>
          <div className="item">
            <button className="button-invert-md hover">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost-md" disabled>
              Button
            </button>
          </div>
          <div className="item">
            <button className="button-invert-md" disabled>
              Button
            </button>
          </div>
          <div className="item">
            <ButtonWithProgress
              options={{
                showProgressAnimation: true,
                buttonTypeClass: 'button-ghost-md',
                cta: 'Button',
              }}
            />
          </div>
          <div className="item">
            <ButtonWithProgress
              options={{
                showProgressAnimation: true,
                buttonTypeClass: 'button-invert-md',
                cta: 'Button',
              }}
            />
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item">
            <button className="button-ghost-sm">Button</button>
          </div>
          <div className="item">
            <button className="button-invert-sm">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost-sm hover">Button</button>
          </div>
          <div className="item">
            <button className="button-invert-sm hover">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost-sm" disabled>
              Button
            </button>
          </div>
          <div className="item">
            <button className="button-invert-sm" disabled>
              Button
            </button>
          </div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item">
            <button className="button-ghost-xs">Button</button>
          </div>
          <div className="item">
            <button className="button-invert-xs">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost-xs hover">Button</button>
          </div>
          <div className="item">
            <button className="button-invert-xs hover">Button</button>
          </div>
          <div className="item">
            <button className="button-ghost-xs" disabled>
              Button
            </button>
          </div>
          <div className="item">
            <button className="button-invert-xs" disabled>
              Button
            </button>
          </div>
        </div>
        <div className="light-buttons toggle-buttons">
          <div className="full-height-grid-item item">Toggle</div>
          <p className="item body button-header">Active</p>
          <div className="item">
            <button className="button-toggle active">Button</button>
          </div>
          <div className="item"></div>
          <p className="item body button-header">Rest</p>
          <div className="item">
            <button className="button-toggle">Button</button>
          </div>
          <div className="item"></div>
          <p className="item button-header">Hover</p>
          <div className="item">
            <button className="button-toggle hover">Button</button>
          </div>
          <div className="item"></div>
          <p className="item button-header">Disabled</p>
          <div className="item">
            <button className="button-toggle" disabled>
              Button
            </button>
          </div>
        </div>
      </div>
      <div className="row mt-2xl">
        <div className="col-12">
          <pre>
            <pre>{buttonsExample}</pre>
            <pre>{buttonProgressExample}</pre>
          </pre>
        </div>
      </div>
    </>
  );
};

export default ButtonsList;
